import type { IPromotionRepository, PromotionListOptions } from '../repositories/IPromotionRepository.js';

export function createListSchemesUseCase({ promotionRepository }: { promotionRepository: IPromotionRepository }) {
  return async function listSchemesUseCase(options: PromotionListOptions) {
    return promotionRepository.listSchemes(options);
  };
}
